import * as _ from 'lodash';
import { FieldTreeService } from '../services/FieldTrees';

export const LaborSafetyService = () => {
  return Class => {
    return class extends Class {
      constructor(props) {
        super(props);
      }

      getFormStatuses(searchParams, notify) {
        if (this.state.loaded && notify) {
          notify();
          return;
        }
        const pageParam = {
          offset: notify ? _.size(this.state.formStatuses) : 0,
        };
        const fieldId = sessionStorage.getItem('field_id');
        let params = {
          form_code: this.state.formCode,
        };
        params = _.assign(params, searchParams, pageParam);
        FieldTreeService.formStatuses(fieldId, params).then(resp => {
          if (resp.result) {
            const formStatuses = resp.data.entities.field_tree_form_statuses;
            if (_.isEmpty(formStatuses) && notify) {
              this.setState({
                loaded: true,
              });
            } else {
              let statuses = notify ? this.state.formStatuses : [];
              _.each(formStatuses, formStatuse => {
                statuses.push(formStatuse);
              });
              this.setState({
                formStatuses: _.cloneDeep(statuses),
                total: resp.data.total,
                loaded: false,
              });
            }
          }
          if (notify) {
            notify();
            return;
          }
        });
      }
    };
  };
};



// WEBPACK FOOTER //
// ./src/utilities/LaborSafety.js